const Microsoft = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4062 11.4041L0 11.4041L0 0L11.4062 0L11.4062 11.4041Z"
        fill="#F1511B"
      />
      <path
        d="M24 11.4041L12.594 11.4041L12.594 0L24 0V11.4041Z"
        fill="#80CC28"
      />
      <path
        d="M11.4059 23.9997H0L0 12.5957L11.4059 12.5957L11.4059 23.9997Z"
        fill="#00ADEF"
      />
      <path
        d="M24 23.9997H12.594L12.594 12.5957L24 12.5957V23.9997Z"
        fill="#FBBC09"
      />
    </svg>
  );
};

export default Microsoft;
